// extracted by mini-css-extract-plugin
export default {"hero":"Quizzes_hero__6Cc0b","hero__title":"Quizzes_hero__title__ffUjx","hero__bg":"Quizzes_hero__bg__G6wwt","hero__ruby":"Quizzes_hero__ruby__JXlYo"};